import React, { useCallback, useLayoutEffect, useState } from 'react';

import { HtmlResetWrapper } from './styled';

interface Props {
  html: string;
}

const HtmlRenderer = (props: Props) => {
  const { html } = props;
  const [, updateState] = useState({});
  const forceUpdate = useCallback(() => updateState({}), []);

  useLayoutEffect(() => {
    forceUpdate();
  }, []);

  return <HtmlResetWrapper className="html-renderer" dangerouslySetInnerHTML={{ __html: html }} />;
};

export default HtmlRenderer;
